import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import style from './index.less';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
function Loading({ tip = 'Loading' }) {
  return (
    <div className={style['spin-box']}>
      <Spin size="large" />
    </div>
  );
}

export default Loading;
